import React, { useEffect } from "react";
import { useState } from "react";
import Controls from "src/components/form/controls/Controls";
import { validationFLFCategoryInput } from "src/pages/FPTLife/utils/validateInput";
import useForm, { Form } from "src/hooks/useForm";
import { isDisableSubmit } from "src/utils";

const initialValue = {
  id: "",
  name: "",
  rogoDevTypeCode: 0,
  rogoDevTypeStr: "",
  devices: [],
};

function FLFCategoryForm(props) {
  const { addOrEdit, recordForEdit, errorsForm } = props;
  const [valueAddNew, setValueAddNew] = useState(initialValue);

  // validation input permission
  const validateFLFCategoryForm = (fieldValues = values) => {
    let temp = validationFLFCategoryInput(fieldValues, { ...errors });

    setErrors({
      ...temp,
    });

    if (fieldValues === values)
      return Object.values(temp).every((x) => x === "");
  };

  const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
    useForm(initialValue, true, validateFLFCategoryForm);

  const onSubmit = (e) => {
    e.preventDefault();

    if (validateFLFCategoryForm()) {
      addOrEdit(values, resetForm);
      setValueAddNew(initialValue);
    }
  };

  useEffect(() => {
    setErrors({
      ...errorsForm,
    });
  }, [errorsForm, setErrors]);

  useEffect(() => {
    if (recordForEdit !== null) {
      setValues({
        ...recordForEdit,
      });
    } else {
      setValues({
        ...valueAddNew,
      });
      setErrors({});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [recordForEdit]);

  const handleOnChange = (e) => {
    handleInputChange(e);

    if (!recordForEdit) {
      const { name, value, type } = e.target;
      setValueAddNew({
        ...valueAddNew,
        [name]: type === "number" ? +value : value,
      });
    }
  };
  return (
    <Form onSubmit={onSubmit}>
      <Controls.Input
        name="name"
        value={values.name}
        label="Name"
        type="text"
        onChange={handleOnChange}
        error={errors.name}
      />
      <Controls.Input
        name="rogoDevTypeCode"
        value={values.rogoDevTypeCode}
        label="Rogo Dev Type Code"
        type="number"
        onChange={handleOnChange}
        error={errors.rogoDevTypeCode}
      />
      <Controls.Input
        name="rogoDevTypeStr"
        value={values.rogoDevTypeStr}
        label="Rogo Dev Type String"
        type="text"
        onChange={handleOnChange}
        error={errors.rogoDevTypeStr}
      />

      <Controls.Button
        sx={{ width: "100%", marginTop: "10px" }}
        type="submit"
        text="Submit"
        disabled={isDisableSubmit(recordForEdit, values)}
      />
    </Form>
  );
}

export default FLFCategoryForm;
